import conservation from './conservation_items';
import indicators from './indicator_items';

export default {
  conservation,
  indicators,
};